@for (odm of (odms$ | async); track odm) {
  <app-odm [odm]="odm"></app-odm>
}
